export const graduates = [
  {
    lastName: "Ahmad",
    firstName: "Mueed",
    finalYearInResidencyProgram: 2007,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente Santa Rosa",
    zipcode: 95403,
  },
  {
    lastName: "Allen",
    firstName: "Clint",
    middleInitial: "Tanner",
    finalYearInResidencyProgram: 2012,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "Johns Hopkins",
    departments: "Head and Neck Surgery",
    zipcode: 20892,
  },
  {
    lastName: "Anderson",
    firstName: "Blake",
    middleInitial: "L.",
    finalYearInResidencyProgram: 2003,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "ENT Associates of Greater Kansas City",
    zipcode: 64114,
  },
  {
    lastName: "Arjmand",
    firstName: "Ellis",
    middleInitial: "M.",
    finalYearInResidencyProgram: 1993,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "Baylor College of Medicine",
    departments: "Ear, Nose and Throat (Otolaryngology)",
    zipcode: 70118,
  },
  {
    lastName: "Bahadori",
    firstName: "Robert",
    middleInitial: "S.",
    finalYearInResidencyProgram: 1995,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Otolaryngology Associates, P.C.",
    zipcode: 22030,
  },
  {
    lastName: "Bailey",
    firstName: "Sean",
    middleInitial: "B.",
    finalYearInResidencyProgram: 1996,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Sound Health Services",
    zipcode: 63127,
  },
  {
    lastName: "Basu",
    firstName: "Devraj",
    finalYearInResidencyProgram: 2006,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "University Of Pennsylvania",
    departments: "Otorhinolaryngology: Head And Neck Surgeryï¿½ï¿½_",
    zipcode: 19104,
  },
  {
    lastName: "Bauer",
    firstName: "Erik",
    middleInitial: "M.",
    finalYearInResidencyProgram: 2005,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Pediatric Ear, Nose and Throat of Atlanta, P.C.",
    zipcode: 30342,
  },
  {
    lastName: "Bello",
    firstName: "Steven",
    middleInitial: "L.",
    finalYearInResidencyProgram: 1993,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Collier Otolaryngologyï¿½ï¿½_",
    zipcode: 34109,
  },
  {
    lastName: "Bigelow",
    firstName: "Douglas",
    middleInitial: "C.",
    finalYearInResidencyProgram: 1990,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "University of Pennsylvania",
    departments: "Otorhinolaryngology: Head and Neck Surgeryï¿½ï¿½_",
    zipcode: 19104,
  },
  {
    lastName: "Blank",
    firstName: "Sarah",
    middleInitial: "J.",
    finalYearInResidencyProgram: 2015,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Inova and Fairfax ENT Facial Plastic Surgery",
    departments: 0,
    zipcode: 22042,
  },
  {
    lastName: "Bradley",
    firstName: "Joseph",
    middleInitial: "P.",
    finalYearInResidencyProgram: 2013,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 63368,
  },
  {
    lastName: "Brenner",
    firstName: "Michael",
    middleInitial: "Joel",
    finalYearInResidencyProgram: 2007,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation:
      "University of Michigan and Kresge Hearing Research Institute",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 48109,
  },
  {
    lastName: "Brown",
    firstName: "Ryan",
    middleInitial: "F.",
    finalYearInResidencyProgram: 2011,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente",
    departments: "Head and Neck Surgery",
    zipcode: 80205,
  },
  {
    lastName: "Castellanos",
    firstName: "Paul",
    middleInitial: "F.",
    finalYearInResidencyProgram: 1994,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "University of Alabama, Birmingham",
    departments: "Otolaryngology",
    zipcode: 35294,
  },
  {
    lastName: "Champion",
    firstName: "Gretchen",
    middleInitial: "A.",
    finalYearInResidencyProgram: 2005,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "The ENT and Allergy Centers of Texas",
    zipcode: 75093,
  },
  {
    lastName: "Coticchia",
    firstName: "James",
    middleInitial: "M.",
    finalYearInResidencyProgram: 1996,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation:
      "Wayne State University School of Medicine and Pediatric ENT Clinic of Michigan",
    departments: "Otolaryngology",
    zipcode: 48201,
  },
  {
    lastName: "Covello",
    firstName: "Leonard",
    middleInitial: "Vincent",
    finalYearInResidencyProgram: 1996,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Covello Sinus Center",
    zipcode: 46321,
  },
  {
    lastName: "Dahm",
    firstName: "J.",
    middleInitial: "David",
    finalYearInResidencyProgram: 1997,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "SoundHealth Services",
    zipcode: 63017,
  },
  {
    lastName: "Dawson",
    firstName: "Steven",
    middleInitial: "M.",
    finalYearInResidencyProgram: 1991,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Proliance Eastside ENT",
    zipcode: 98034,
  },
  {
    lastName: "Day",
    firstName: "Andrew",
    middleInitial: "T.",
    finalYearInResidencyProgram: 2016,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "UT Southwestern",
    departments: "Otolaryngology ï¿½ï¿½_ Head and Neck Surgery",
    zipcode: 75390,
  },
  {
    lastName: "Debnath",
    firstName: "Indranil (Nick)",
    maidenOrOtherName:
      "Uses first name of Nick. Pubs in Scopus under both names.",
    finalYearInResidencyProgram: 2008,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Florida Otolaryngology Group, P.A.",
    zipcode: 32792,
  },
  {
    lastName: "Deddens",
    firstName: "Alan",
    middleInitial: "E.",
    finalYearInResidencyProgram: 1993,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Piedmont Health Care Ear, Nose, and Throat",
    zipcode: 28677,
  },
  {
    lastName: "Desai",
    firstName: "Shaun",
    middleInitial: "Chandra",
    finalYearInResidencyProgram: 2014,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Johns Hopkins",
    departments: "Otolaryngology - Head and Neck Surgery",
    zipcode: 21204,
  },
  {
    lastName: "Patil",
    firstName: "Reena",
    maidenOrOtherName: "Married name is Patil",
    finalYearInResidencyProgram: 2003,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "University of Cincinnati",
    departments: "Otolaryngology",
    zipcode: 45219,
  },
  {
    lastName: "Drescher",
    firstName: "Andrew",
    middleInitial: "Jeremy",
    finalYearInResidencyProgram: 2009,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 63110,
  },
  {
    lastName: "Durakovic",
    firstName: "Nedim",
    finalYearInResidencyProgram: 2017,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 63110,
  },
  {
    lastName: "Elluru",
    firstName: "Ravindhra",
    middleInitial: "G.",
    finalYearInResidencyProgram: 2001,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation:
      "Wright State University; Dayton Children's Hospital; Cincinnati Children's Hospital",
    departments: "Surgery and Pediatrics",
    zipcode: 45402,
  },
  {
    lastName: "Engel",
    firstName: "Samuel",
    middleInitial: "H.",
    finalYearInResidencyProgram: 2007,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "Jersey Shore University Medical Center and the K. Hovnanian Childrenï¿½ï¿½_s Hospital, and Costal Ear, Nose and Throat",
    zipcode: 7753,
  },
  {
    lastName: "Esselman",
    firstName: "Gregory",
    middleInitial: "H.",
    finalYearInResidencyProgram: 1999,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Aiken Ear Nose and Throat",
    zipcode: 29801,
  },
  {
    lastName: "Evans",
    firstName: "Allen",
    middleInitial: "M.",
    finalYearInResidencyProgram: 1992,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "Central California Ear, Nose and Throat (CCENT) MEDICAL GROUP",
    zipcode: 93720,
  },
  {
    lastName: "Fenwick",
    firstName: "Jeffrey",
    middleInitial: "R.",
    finalYearInResidencyProgram: 1991,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Cox Medical Group",
    zipcode: 65807,
  },
  {
    lastName: "Fina",
    firstName: "Manuela",
    finalYearInResidencyProgram: 2001,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "University of Minnesota",
    departments: "Otolaryngology, Head and Neck Surgery",
    zipcode: 55455,
  },
  {
    lastName: "Forsen",
    firstName: "James",
    middleInitial: "W.",
    finalYearInResidencyProgram: 1994,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Sound Health Services",
    zipcode: 63141,
  },
  {
    lastName: "Fraley",
    firstName: "Patrick",
    middleInitial: "Lee",
    finalYearInResidencyProgram: 2009,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "Ear, Nose & Throat Center of Conwayï¿½ï¿½_",
    zipcode: 72034,
  },
  {
    lastName: "Gale",
    firstName: "Derrick",
    middleInitial: "Cripps",
    finalYearInResidencyProgram: 2018,
    currentAffiliation: "Texas Center for Facial Plastic Surgery",
    zipcode: 84130,
  },
  {
    lastName: "Garcia",
    firstName: "Phillip",
    finalYearInResidencyProgram: 1993,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Springfield Clinic",
    zipcode: 62703,
  },
  {
    lastName: "Gaylis",
    firstName: "Brendan",
    finalYearInResidencyProgram: 1991,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Scripps",
    zipcode: 92037,
  },
  {
    lastName: "Genden",
    firstName: "Eric",
    middleInitial: "M.",
    finalYearInResidencyProgram: 1998,

    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "Icahn School of Medicine at Mount Sinai",
    departments: "Otolaryngology ï¿½ï¿½_ Head and Neck Surgery",
    zipcode: 10029,
  },
  {
    lastName: "Ghogomu",
    firstName: "Nsangou",
    middleInitial: "T.",
    finalYearInResidencyProgram: 2014,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente",
    departments: 0,
    zipcode: 80205,
  },
  {
    lastName: "Gill",
    firstName: "Sarvjit",
    middleInitial: "S.",
    finalYearInResidencyProgram: 1998,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "lpine Ear, Nose, Throat",
    zipcode: 80524,
  },
  {
    lastName: "Giraud",
    firstName: "Lissette",
    middleInitial: "Carcano",
    finalYearInResidencyProgram: 2002,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Mount Sinai",
    departments: "Otolaryngology",
    zipcode: 10003,
  },
  {
    lastName: "Goheen",
    firstName: "Barbara",
    middleInitial: "L.",
    maidenOrOtherName:
      "Current married name is Brodish. Also published under Barbara Goheen-Robillard -ca. 1996).",
    finalYearInResidencyProgram: 2002,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kingston Head and Neck Physicians and Surgeons",
    zipcode: 28501,
  },
  {
    lastName: "Gould",
    firstName: "James",
    middleInitial: "D.",
    finalYearInResidencyProgram: 1999,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "St. Louis Sinus Center and Synergy ENT Specialists",
    zipcode: 63131,
  },
  {
    lastName: "Graboyes",
    firstName: "Evan",
    middleInitial: "M.",
    finalYearInResidencyProgram: 2016,

    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Medical University of South Carolina",
    departments: "Otolaryngology - Head and Neck Surgery",
    zipcode: 29425,
  },
  {
    lastName: "Greiman",
    firstName: "Marshall",
    middleInitial: "C.",
    finalYearInResidencyProgram: 1990,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Mercy Clinics Ear, Nose and Throat West",
    zipcode: 50325,
  },
  {
    lastName: "Grindler",
    firstName: "David",
    finalYearInResidencyProgram: 2016,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente",
    zipcode: 80205,
  },
  {
    lastName: "Ha",
    firstName: "Dun",
    middleInitial: "Huu",
    finalYearInResidencyProgram: 2004,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Magan Medical Clinic",
    zipcode: 91723,
  },
  {
    lastName: "Hanson",
    firstName: "Jason",
    middleInitial: "M.",
    finalYearInResidencyProgram: 1999,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Northwest Otolaryngology",
    zipcode: 63044,
  },
  {
    lastName: "Hessler",
    firstName: "Jill",
    finalYearInResidencyProgram: 2005,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Hessler Plastic Surgery / Stanford University",
    departments: "OHNS/Otolaryngology/Head & Neck Surgery",
    zipcode: 94306,
  },
  {
    lastName: "Hogikyan",
    firstName: "Norman",
    middleInitial: "Dertad",
    finalYearInResidencyProgram: 1994,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "University of Michigan",
    departments: "Otolaryngology-Head and Neck Surgery AND Music",
    zipcode: 48109,
  },
  {
    lastName: "Hsu",
    firstName: "Kenneth",
    middleInitial: "S.",
    finalYearInResidencyProgram: 2005,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "The ENT and Allergy Centers of Texas",
    zipcode: 75093,
  },
  {
    lastName: "Jacob",
    firstName: "Abraham",
    finalYearInResidencyProgram: 2004,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Ear & Hearing at the Center for Neurosciences",
    zipcode: 85718,
  },
  {
    lastName: "Jenison",
    firstName: "Gary",
    middleInitial: "Lynn",
    finalYearInResidencyProgram: 1995,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Jenison Ear Nose & Throat",
    zipcode: 45601,
  },
  {
    lastName: "Jensen",
    firstName: "Daniel",
    middleInitial: "R.",
    finalYearInResidencyProgram: 2013,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "University of Missouri-Kansas City School of Medicine",
    departments: "Pediatric Surgery",
    zipcode: 64108,
  },
  {
    lastName: "Jiang",
    firstName: "Wen",
    finalYearInResidencyProgram: 2006,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation:
      "University of California, San Diego; Rady Children's Hospital - San Diego",
    departments: "Surgery",
    zipcode: 92093,
  },
  {
    lastName: "Judd",
    firstName: "Nancy",
    middleInitial: "P.",
    finalYearInResidencyProgram: 2014,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente",
    departments: 0,
    zipcode: 22046,
  },
  {
    lastName: "Jung",
    firstName: "Matthew",
    finalYearInResidencyProgram: 2016,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Coastal Ear Nose and Throat, NJ",
    zipcode: 98506,
  },
  {
    lastName: "Jyung",
    firstName: "Robert",
    middleInitial: "W.",
    finalYearInResidencyProgram: 1995,

    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "Rutgers New Jersey Medical School",
    departments: "Otolaryngology",
    zipcode: 7101,
  },
  {
    lastName: "Kao",
    firstName: "Wee Tin (Katherine)",
    finalYearInResidencyProgram: 2018,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "University of Miami Miller School of Medicine",
    departments: "Otolaryngology",
    zipcode: 77030,
  },
  {
    lastName: "Karni",
    firstName: "Ron",
    middleInitial: "J.",
    finalYearInResidencyProgram: 2008,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "University of Texas, Houston McGovern Medical School",
    departments: "Otorhinolaryngologyï¿½ï¿½_Head & Neck Surgery",
    zipcode: 77030,
  },
  {
    lastName: "Kitch",
    firstName: "Russell",
    middleInitial: "D.",
    finalYearInResidencyProgram: 1991,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Low Country ENT; Medical University of South Carolina",
    departments: "Otolaryngology - Head and Neck Surgery",
    zipcode: 29406,
  },
  {
    lastName: "Kneass",
    firstName: "Zachary",
    middleInitial: "T.",
    finalYearInResidencyProgram: 2013,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente",
    departments: 0,
    zipcode: 80205,
  },
  {
    lastName: "Kokoska",
    firstName: "Mimi",
    middleInitial: "S.",
    maidenOrOtherName: "Gee",
    finalYearInResidencyProgram: 1996,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Blue Shield of California",
    zipcode: 94117,
  },
  {
    lastName: "Law",
    firstName: "Jonathan",
    middleInitial: "H.",
    finalYearInResidencyProgram: 2017,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Middle Tennessee Ear, Nose & Throat Specialists",
    zipcode: 93720,
  },
  {
    lastName: "Lawson",
    firstName: "Carla",
    middleInitial: "Michelle",
    maidenOrOtherName: "Huff",
    finalYearInResidencyProgram: 2003,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "GBMC Health",
    zipcode: 21204,
  },
  {
    lastName: "Layland",
    firstName: "Michael",
    middleInitial: "K.",
    finalYearInResidencyProgram: 2004,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "Ear Nose & Throat Center in Chicago and Advocate Health Care",
    zipcode: 60068,
  },
  {
    lastName: "Lee",
    firstName: "Patty",
    finalYearInResidencyProgram: 1996,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Otolaryngology Associates PC; Inova Hospitals",
    zipcode: 22030,
  },
  {
    lastName: "Lee",
    firstName: "Kenneth",
    middleInitial: "H.",
    finalYearInResidencyProgram: 2006,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "University of Texas, Southwestern; Children's Health",
    departments: "Otolaryngology",
    zipcode: 75235,
  },
  {
    lastName: "Lieu",
    firstName: "Judith",
    middleInitial: "C.",
    maidenOrOtherName: "Cho",
    finalYearInResidencyProgram: 1998,

    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 63110,
  },
  {
    lastName: "Limb",
    firstName: "Andrew",
    middleInitial: "J.",
    finalYearInResidencyProgram: 2000,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Adventist Health",
    zipcode: 95219,
  },
  {
    lastName: "Friesen",
    firstName: "Tzyy-Nong (Tina Liou)",
    finalYearInResidencyProgram: 2018,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "UC San Diego",
    zipcode: 92093,
  },
  {
    lastName: "Maack",
    firstName: "Richard",
    middleInitial: "W.",
    finalYearInResidencyProgram: 1990,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "ENT Associates, Inc./Sound Health Services / Synergi Facial Surgery/ Washington University",
    departments: "Otolaryngology",
    zipcode: 63141,
  },
  {
    lastName: "MacDonald, III",
    firstName: "Robert",
    middleInitial: "R.",
    finalYearInResidencyProgram: 1999,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Midwest ENT Centre",
    zipcode: 63376,
  },
  {
    lastName: "Magill",
    firstName: "Christina",
    maidenOrOtherName: "Kenney",
    finalYearInResidencyProgram: 2011,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Alyeska Center For Facial Plastic Surgery & ENT",
    departments: 0,
    zipcode: 99508,
  },
  {
    lastName: "McJunkin",
    firstName: "Jonathan",
    middleInitial: "L.",
    finalYearInResidencyProgram: 2010,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 61822,
  },
  {
    lastName: "McLear",
    firstName: "Patrick",
    middleInitial: "W.",
    finalYearInResidencyProgram: 1992,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Greenville Health System, South Carolina",
    zipcode: 29615,
  },
  {
    lastName: "Milov",
    firstName: "Simon",
    finalYearInResidencyProgram: 2011,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "Doctors Hospital at Renaissance/Ear, Nose, And Throat Institute at Renaissance",
    departments: "Ear, Nose, And Throat Institute",
    zipcode: 78539,
  },
  {
    lastName: "Minoli",
    firstName: "John",
    middleInitial: "J.",
    finalYearInResidencyProgram: 1991,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Minoli Plastic Surgery Clinic",
    zipcode: 89052,
  },
  {
    lastName: "Moradzadeh",
    firstName: "Arash",
    finalYearInResidencyProgram: 2010,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "AM Facial Plastics",
    zipcode: 90211,
  },
  {
    lastName: "Nason",
    firstName: "Robert",
    finalYearInResidencyProgram: 2012,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "ENT Specialists of Austin",
    departments: 0,
    zipcode: 78705,
  },
  {
    lastName: "Nettar",
    firstName: "Kartik",
    middleInitial: "D.",
    finalYearInResidencyProgram: 2010,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente, Southern California",
    zipcode: 91367,
  },
  {
    lastName: "Newland",
    firstName: "Donald",
    middleInitial: "E.",
    finalYearInResidencyProgram: 2003,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Texas ENT Specialists",
    zipcode: 77380,
  },
  {
    lastName: "Nguyen",
    firstName: "Tan",
    middleInitial: "D.",
    finalYearInResidencyProgram: 1999,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Private practice",
    zipcode: 78504,
  },
  {
    lastName: "O'Bert",
    firstName: "Robert",
    middleInitial: "J.",
    finalYearInResidencyProgram: 2009,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Ballas ENT Consultants- St. Louis",
    zipcode: 63131,
  },
  {
    lastName: "Ogden",
    firstName: "Allison",
    middleInitial: "M",
    finalYearInResidencyProgram: 2007,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 63110,
  },
  {
    lastName: "O'Halloran",
    firstName: "Laurence",
    middleInitial: "R.",
    finalYearInResidencyProgram: 1994,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "Fairfax ENT & Facial Plastic Surgery, Falls Church, Virginia",
    zipcode: 22042,
  },
  {
    lastName: "O'Hare",
    firstName: "Timothy",
    middleInitial: "J.",
    finalYearInResidencyProgram: 1998,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Space Coast Ear, Nose, Throat and Associates",
    zipcode: 32901,
  },
  {
    lastName: "Okuyemi",
    firstName: "Oluwafunmilola",
    middleInitial: "T.",
    finalYearInResidencyProgram: 2015,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "UNLV School of Medicine",
    departments: "Head and Neck Oncology and Microvascular Surgery",
    zipcode: 89102,
  },
  {
    lastName: "Olomu",
    firstName: "Osarenoma",
    middleInitial: "U.",
    finalYearInResidencyProgram: 2014,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Mayo Clinic-Florida",
    departments: 0,
    zipcode: 32224,
  },
  {
    lastName: "Page",
    firstName: "Nathan",
    middleInitial: "C.",
    finalYearInResidencyProgram: 2009,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Phoenix Children's Hospital",
    zipcode: 85016,
  },
  {
    lastName: "Paniello",
    firstName: "Randal",
    middleInitial: "C.",
    finalYearInResidencyProgram: 1990,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 63110,
  },
  {
    lastName: "Park",
    firstName: "Andrea",
    middleInitial: "M.",
    finalYearInResidencyProgram: 2017,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "UCLA, Facial Plastic and Reconstructive Surgery",
    departments: "Facial Plastic and Reconstructive Surgery",
    zipcode: 94115,
  },
  {
    lastName: "Park",
    firstName: "John",
    middleInitial: "Yong",
    finalYearInResidencyProgram: 2000,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "ENT Associates, Inc. - a division of Sound Health Services",
    zipcode: 63017,
  },
  {
    lastName: "Patel",
    firstName: "Urjeet",
    middleInitial: "A.",
    finalYearInResidencyProgram: 2002,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "Feinberg School of Medicine, Northwestern University",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 60611,
  },
  {
    lastName: "Paydarfar",
    firstName: "Joseph",
    middleInitial: "A.",
    finalYearInResidencyProgram: 2001,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation:
      "Dartmouth Geisel School of Medicine; Thayer School of Engineering at Dartmouth; Dartmouth-Hitchcock Medical Center",
    departments: "Otolaryngology; Engineering",
    zipcode: 3756,
  },
  {
    lastName: "Phillips",
    firstName: "John",
    middleInitial: "G.",
    finalYearInResidencyProgram: 1992,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "University of South Carolina School of Medicine- Greenville; Greenville Health System",
    departments: "Surgery",
    zipcode: 29605,
  },
  {
    lastName: "Prager",
    firstName: "Jeremy",
    middleInitial: "D.",
    finalYearInResidencyProgram: 2008,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation:
      "University of Colorado School of Medicine; Children's Hospital Colorado",
    departments: "Otolaryngology",
    zipcode: 80045,
  },
  {
    lastName: "Pugliano",
    firstName: "Frederic",
    middleInitial: "A.",
    finalYearInResidencyProgram: 1998,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "St. Louis ENT Health- a division of Sound Health Services",
    zipcode: 63127,
  },
  {
    lastName: "Raval",
    firstName: "Jeffrey",
    middleInitial: "R.",
    finalYearInResidencyProgram: 2000,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Raval Facial Aesthetics & ENT, PC",
    zipcode: 80209,
  },
  {
    lastName: "Rich",
    firstName: "Jason",
    middleInitial: "T.",
    finalYearInResidencyProgram: 2011,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 63110,
  },
  {
    lastName: "Roland",
    firstName: "Lauren",
    maidenOrOtherName: "Tashima",
    finalYearInResidencyProgram: 2018,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Emory University",
    zipcode: 63110,
  },
  {
    lastName: "Sand",
    firstName: "Jordan",
    middleInitial: "P.",
    finalYearInResidencyProgram: 2016,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Spokane Center for Facial Plastic Surgery",
    zipcode: 99201,
  },
  {
    lastName: "Sargent",
    firstName: "Eric",
    middleInitial: "W.",
    finalYearInResidencyProgram: 1992,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "Wayne State University School of Medicine; Michigan Ear Institute",
    departments: "Otolaryngology, Head and Neck Surgery",
    zipcode: 48334,
  },
  {
    lastName: "Sater",
    firstName: "Gregory",
    middleInitial: "R.",
    finalYearInResidencyProgram: 1997,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente, Gaithersburg",
    zipcode: 20879,
  },
  {
    lastName: "Sequeira",
    firstName: "Sunitha",
    middleInitial: "M.",
    finalYearInResidencyProgram: 2013,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "BJC HealthCare; Ballas ENT Consultants",
    zipcode: 63131,
  },
  {
    lastName: "Sharon",
    firstName: "Jeffrey",
    middleInitial: "D.",
    finalYearInResidencyProgram: 2014,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "University of California, San Francisco",
    departments: "Otolaryngology ï¿½ï¿½_ Head and Neck Surgery",
    zipcode: 94117,
  },
  {
    lastName: "Sirjani",
    firstName: "Davud",
    middleInitial: "B.",
    finalYearInResidencyProgram: 2008,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation: "Stanford School of Medicine; VA, Palo Alto",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 94305,
  },
  {
    lastName: "Skarada",
    firstName: "Douglas",
    middleInitial: "J.",
    finalYearInResidencyProgram: 2001,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Modern Nose Clinic in Salem, Oregon",
    zipcode: 97302,
  },
  {
    lastName: "Slattery",
    firstName: "Eric",
    middleInitial: "L.",
    finalYearInResidencyProgram: 2013,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "ENT Center of Utah",
    departments: 0,
    zipcode: 84102,
  },
  {
    lastName: "Solowski",
    firstName: "Nancy",
    middleInitial: "L.",
    finalYearInResidencyProgram: 2012,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Johns Hopkins Medicine/Howard County General Hospital",
    departments: "Surgery, Otolaryngology",
    zipcode: 21044,
  },
  {
    lastName: "Spataro",
    firstName: "Emily",
    middleInitial: "A.",
    finalYearInResidencyProgram: 2017,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Washington University School of Medicine in St. Louis",
    departments: "Otolaryngology-Head and Neck Surgery",
    zipcode: 63110,
  },
  {
    lastName: "Strominger",
    firstName: "Robert",
    middleInitial: "N.",
    finalYearInResidencyProgram: 1997,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "University of Rochester Medical Center; Cayuga ENT ; also see Ithaca College Voice and Swallowing Clinic https://www.ithaca.edu/hshp/clinics/voice_and_swallowing/",
    departments: "Otolaryngology",
    zipcode: 14618,
  },
  {
    lastName: "Sumer",
    firstName: "Baran",
    middleInitial: "D.",
    finalYearInResidencyProgram: 2006,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "UT Southwestern Medical Center",
    departments: "Otolaryngology; Biomedical Engineering",
    zipcode: 75390,
  },
  {
    lastName: "Sun",
    firstName: "John",
    middleInitial: "C.",
    finalYearInResidencyProgram: 2002,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Orange County Ear, Nose and Throat Associates",
    zipcode: 92618,
  },
  {
    lastName: "Sun",
    firstName: "Paul",
    middleInitial: "C.",
    finalYearInResidencyProgram: 2001,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Orange County Ear, Nose and Throat Associates",
    zipcode: 92618,
  },
  {
    lastName: "Sunwoo",
    firstName: "John",
    middleInitial: "B.",
    finalYearInResidencyProgram: 2003,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "Stanford University; Stanford Cancer Center",
    departments:
      "Otolaryngology-Head and Neck Surgery; (By courtesy) Dermatology",
    zipcode: 94304,
  },
  {
    lastName: "Tarasidis",
    firstName: "Gregory",
    finalYearInResidencyProgram: 1997,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Greenwood Ear Nose and Throat",
    zipcode: 29646,
  },
  {
    lastName: "Thomas",
    firstName: "Tom",
    finalYearInResidencyProgram: 2010,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Atlantic Health System and Morristown Medical Center",
    zipcode: 7960,
  },
  {
    lastName: "Townsend",
    firstName: "Melanie",
    middleInitial: "E.",
    maidenOrOtherName: "Huffman",
    finalYearInResidencyProgram: 2018,
    currentAffiliation: "University of Miami Miller School of Medicine",
    departments: "Otolaryngology",
    zipcode: 40292,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
  },
  {
    lastName: "Tseng",
    firstName: "Charles",
    middleInitial: "J.",
    finalYearInResidencyProgram: 1999,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Kaohsiung Medical University",
    zipcode: "Taiwan",
  },
  {
    lastName: "Uppaluri",
    firstName: "Ravindra",
    finalYearInResidencyProgram: 2000,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 5,
    currentAffiliation: "Harvard Medical School; DF/BWCC",
    departments: "Otolaryngology; Surgery",
    zipcode: 2215,
  },
  {
    lastName: "Voelker",
    firstName: "Courtney",
    middleInitial: "Christine Joan",
    finalYearInResidencyProgram: 2012,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Keck School of Medicine at USC",
    departments: "Otolaryngology",
    zipcode: 90033,
  },
  {
    lastName: "Wang",
    firstName: "Eric",
    middleInitial: "W.",
    finalYearInResidencyProgram: 2010,

    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation:
      "University of Pittsburgh; Children's Hospital of Pittsburgh",
    departments: "Otolaryngology",
    zipcode: 15224,
  },
  {
    lastName: "Warren",
    firstName: "James",
    middleInitial: "Doug",
    finalYearInResidencyProgram: 1990,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Boulder Valley Ear, Nose & Throat",
    zipcode: 80303,
  },
  {
    lastName: "West",
    firstName: "Steven",
    middleInitial: "E.",
    finalYearInResidencyProgram: 2000,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "Gateway Ear, Nose and Throat- a division of Sound Heath Services",
    zipcode: 63127,
  },
  {
    lastName: "Wilson",
    firstName: "Ewain",
    middleInitial: "P.",
    finalYearInResidencyProgram: 1995,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Wilkes Regional Medical Center, North Carolina",
    zipcode: 28659,
  },
  {
    lastName: "Wineland",
    firstName: "Andre",
    finalYearInResidencyProgram: 2015,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Arkansas Children's Hospital",
    departments: "Otolaryngology",
    zipcode: 72202,
  },
  {
    lastName: "Woolley",
    firstName: "Audie",
    middleInitial: "L.",
    finalYearInResidencyProgram: 1994,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation:
      "University of Alabama at Birmingham; Children's Hospital of Alabama; Pediatric ENT Associates",
    departments:
      "Surgery; Pediatrics- Division of Otolaryngology Head and Neck Surgery",
    zipcode: 35294,
  },
  {
    lastName: "Yian",
    firstName: "Christopher",
    middleInitial: "H.",
    finalYearInResidencyProgram: 2002,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Orange County Ear, Nose and Throat Associates",
    zipcode: 92653,
  },
  {
    lastName: "Young",
    firstName: "Nwanmegha",
    middleInitial: "O.",
    finalYearInResidencyProgram: 2006,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Yale School of Medicine",
    departments: "Surgery (Otolaryngology)",
    zipcode: 6510,
  },
  {
    lastName: "Yung",
    firstName: "Katherine",
    middleInitial: "C.",
    finalYearInResidencyProgram: 2008,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 4,
    currentAffiliation:
      "University of California, San Francisco; UCSF Medical Center- Voice and Swallowing Center",
    departments:
      "Otolaryngology-Head and Neck Surgery; Division of Laryngology",
    zipcode: 94115,
  },
  {
    lastName: "Zenga",
    firstName: "Joseph",
    finalYearInResidencyProgram: 2017,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    currentAffiliation: "Medical College of Wisconsin",
    departments: "Otolaryngology",
    zipcode: 53226,
  },
  {
    lastName: "Zhuang",
    firstName: "Lei",
    finalYearInResidencyProgram: 2009,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    currentAffiliation: "Kaiser Permanente, Southern California",
    zipcode: 91367,
  },
  {
    lastName: "Chen",
    firstName: "Collin",
    middleInitial: "C.",
    finalYearInResidencyProgram: 2019,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 63104,
  },
  {
    lastName: "Vila",
    firstName: "Peter",
    middleInitial: "M.",
    finalYearInResidencyProgram: 2019,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 97239,
  },
  {
    lastName: "L'Esperance",
    firstName: "Heidi",
    finalYearInResidencyProgram: 2019,
    zipcode: 55811,
  },
  {
    lastName: "Bhatt",
    firstName: "Neel",
    middleInitial: "K.",
    finalYearInResidencyProgram: 2019,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 98005,
  },
  {
    lastName: "Gross",
    firstName: "Jennifer",
    finalYearInResidencyProgram: 2019,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 30308,
  },
  {
    lastName: "Dang",
    firstName: "Rajan",
    finalYearInResidencyProgram: 2021,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 35801,
  },
  {
    lastName: "Ettyreddy",
    firstName: "Abhinav",
    finalYearInResidencyProgram: 2021,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 15090,
  },
  {
    lastName: "Sinha",
    firstName: "Parul",
    finalYearInResidencyProgram: 2021,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 77030,
  },
  {
    lastName: "Slijepcevic",
    firstName: "Allison",
    finalYearInResidencyProgram: 2021,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 27101,
  },
  {
    lastName: "Bauer",
    firstName: "Eric",
    finalYearInResidencyProgram: 2020,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 45402,
  },
  {
    lastName: "Bertroche",
    firstName: "J. Tyler",
    finalYearInResidencyProgram: 2020,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 50323,
  },
  {
    lastName: "Gantz",
    firstName: "Jay",
    finalYearInResidencyProgram: 2020,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 97239,
  },
  {
    lastName: "Wick",
    firstName: "Elizabeth",
    finalYearInResidencyProgram: 2020,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 63141,
  },
  {
    lastName: "Zolkind",
    firstName: "Paul",
    finalYearInResidencyProgram: 2020,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 63110,
  },
  {
    lastName: "Jiramongkolchai",
    firstName: "Pawina",
    finalYearInResidencyProgram: 2022,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 63110,
  },
  {
    lastName: "Valenzuela",
    firstName: "Carla",
    finalYearInResidencyProgram: 2022,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 1,
    zipcode: 48109,
  },
  {
    lastName: "Skillington",
    firstName: "S. Andrew",
    finalYearInResidencyProgram: 2022,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 63141,
  },
  {
    lastName: "Chen",
    firstName: "Stephanie",
    finalYearInResidencyProgram: 2022,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 77058,
  },
  {
    lastName: "Lindburg",
    firstName: "Miranda",
    finalYearInResidencyProgram: 2022,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 63110,
  },
  {
    lastName: "Lee",
    firstName: "Jake",
    finalYearInResidencyProgram: 2023,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 94304,
  },
  {
    lastName: "Craig",
    firstName: "Ethan",
    finalYearInResidencyProgram: 2023,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 1,
    zipcode: 63141,
  },
  {
    lastName: "Ramirez",
    firstName: "Ricardo",
    finalYearInResidencyProgram: 2023,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 65807, // I know it's supposed to be 10128 but modified to show up on map
  },
  {
    lastName: "Sciegienka",
    firstName: "Sebastian",
    finalYearInResidencyProgram: 2023,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 55455,
  },
  {
    lastName: "Douglas",
    firstName: "Zachary",
    finalYearInResidencyProgram: 2023,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 0,
    zipcode: 63131,
  },
  {
    lastName: "Chang",
    firstName: "Katherine",
    finalYearInResidencyProgram: 2024,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 1,
    zipcode: 30308,
  },
  {
    lastName: "Last",
    firstName: "Aisling",
    finalYearInResidencyProgram: 2024,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 63110,
  },
  {
    lastName: "Sindhar",
    firstName: "Sampat",
    finalYearInResidencyProgram: 2024,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 3,
    zipcode: 98034,
  },
  {
    lastName: "Wahle",
    firstName: "Ben",
    finalYearInResidencyProgram: 2024,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 1,
    zipcode: 47403,
  },
  {
    lastName: "Wamkpah",
    firstName: "Nneoma",
    finalYearInResidencyProgram: 2024,
    academicRank0IfNotRanked1fellow2instructor3asstProf4assocProf5professor: 1,
    zipcode: 48104,
  },
];
